import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface TabProps {
  isActive?: boolean;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
}

const Tab: React.FC<TabProps> = ({
  isActive = false,
  onClick,
  children,
  className = '',
}) => {
  return (
    <button
      className={classNames(
        'py-3 px-2 font-medium outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        {
          'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400': isActive,
          'text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 border-b-2 border-transparent': !isActive,
        },
        className
      )}
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
    >
      {children}
    </button>
  );
};

interface ListProps {
  children: ReactNode;
  className?: string;
}

const List: React.FC<ListProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={classNames(
        'flex border-b border-gray-200 dark:border-gray-700',
        className
      )}
      role="tablist"
    >
      {children}
    </div>
  );
};

interface PanelProps {
  children: ReactNode;
  className?: string;
}

const Panel: React.FC<PanelProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={classNames(
        'py-4',
        className
      )}
      role="tabpanel"
    >
      {children}
    </div>
  );
};

export const TabsNamespace = {
  Tab,
  List,
  Panel,
};

export default TabsNamespace;